import stickerAmbos from "../images/AMBOS.png";
import stickerTope from "../images/TOPE.png";
import stickerCubrePolvo from "../images/CUBREPOLVO.png";

// Mapea el StickerTipo que devuelve el backend (v2) a su imagen y texto alt.
// 'NINGUNO' (o cualquier valor desconocido) no tiene sticker → null.
const STICKERS = {
  AMBOS: { src: stickerAmbos, alt: "Incluye accesorios: rebote y cubre polvo" },
  TOPE: { src: stickerTope, alt: "Incluye accesorio: tope de rebote" },
  CUBREPOLVO: { src: stickerCubrePolvo, alt: "Incluye accesorio: cubre polvo" },
};

export const getAccesorioSticker = (stickerTipo) => STICKERS[stickerTipo] || null;
